module.exports = __webpack_public_path__ + "static/media/muiRed.dbc06ee7.svg";